import React from "react";
import { SEGMENT_BZA, SEGMENT_BZA_ID, SEGMENT_CMC, SEGMENT_CMC_ID } from "../constants";
import SegmentedProductPage from "../SegmentedProductPage";
import BusinessOperatorAirportData from "./BusinessOperatorAirportData";
import CommercialOperatorAirportData from "./CommercialOperatorAirportData";
import { productPageProps } from "../../common/types/product";

export default function OperatorAirportData({
	packageName,
	subscribeLink,
	testimonials,
}: productPageProps) {
	return (
		<SegmentedProductPage
			tabsDefinition={[
				{
					id: SEGMENT_CMC_ID,
					title: `${SEGMENT_CMC} ${packageName}`,
					renderContent: (tabsNav) => (
						<CommercialOperatorAirportData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
				{
					id: SEGMENT_BZA_ID,
					title: `${SEGMENT_BZA} ${packageName}`,
					renderContent: (tabsNav) => (
						<BusinessOperatorAirportData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
			]}
		/>
	);
}
